import {useEffect, useMemo} from 'react';

import {useLocation} from 'react-router-dom';

import {buildDeeplink} from '@/utils/buildDeeplink';

export default function GoRedirect() {
  const {pathname} = useLocation();

  const deeplinkPath = useMemo(
    () => pathname.replace('/golink', ''),
    [pathname],
  );

  useEffect(() => {
    const deeplink = buildDeeplink(deeplinkPath);
    window.location.href = deeplink;
  }, [deeplinkPath]);

  return <p>Opening Modak App to {deeplinkPath}</p>;
}
